import React from "react";
import { SiUpwork } from "react-icons/si";
import WebsiteShowcaseSection from "../sections/WebsiteShowcaseSection";
import { BRAND_CONFIGS, type BrandType } from "../../../config/brandConfig";
import {
  Target,
  Star,
  BadgeCheck,
  Info,
  AlertTriangle,
  Route,
  Wand2,
  CheckCircle,
  Lightbulb,
  FileCheck,
  Handshake
} from "lucide-react";

type Props = {
  proposal: any;
  getIconFromKeyword: (text: string) => any;
};

const ClassicTemplate: React.FC<Props> = ({ proposal, getIconFromKeyword }) => {

  const stats =
    proposal.stats || [
      { value: "100%", label: "JOB SUCCESS" },
      { value: "100%", label: "CLIENT SATISFACTION" },
      { value: "100%", label: "OUTCOME SUCCESS" },
      { value: "100%", label: "REVENUE GROWTH" },
    ];

  return (
    <div className="min-h-screen bg-[#F5F7F6] py-0 sm:py-16 px-4 font-['Plus_Jakarta_Sans']">
      <div className="max-w-5xl mx-auto space-y-14">

        <div className="bg-white rounded-3xl p-14 shadow-sm">

          <div className="sm:flex justify-between items-start">

            <div className="sm:flex gap-8 sm:items-start">
<div className="w-32 h-32 bg-gray-100 rounded-3xl overflow-hidden shadow-md">
  <img
    src={
      proposal.profileImage && proposal.profileImage.trim() !== ""
        ? proposal.profileImage
        : "/upwork.png"
    }
    alt="Profile"
    className="w-full h-full object-cover"
  />
</div>

              <div>
                <h1 className="text-[30px] sm:text-[48px] py-1 sm:py-0 font-extrabold text-[#001E00]">
                  {proposal.fullName || "Irfan Baig"}
                </h1>

<div className="flex gap-4 mt-5">

  <div className="flex items-center gap-2 bg-[#F3F4F6] px-2 sm:px-6 py-2 rounded-full text-sm font-semibold text-gray-700">
    <Star
      size={18}
      className="text-[#14A800]"
      fill="#14A800"
      strokeWidth={1.5}
    />
    TOP RATED
  </div>

  <div className="flex items-center gap-2 bg-[#F3F4F6] px-2 sm:px-6 py-2 rounded-full text-sm font-semibold text-gray-700 sm:mt-0 mt-2">
    <BadgeCheck
      size={18}
      className="text-[#fff]"
      fill="#14A800"
      strokeWidth={1.5}
    />
    VERIFIED
  </div>

</div>

              </div>
            </div>

            <div className="sm:text-right py-6 sm:py-0 text-[18px] sm:text-[24px] font-bold text-[#14A800] max-w-md">
              {proposal.tagline ||
                "CMS Developer | WordPress, Shopify, Wix & Squarespace Expert"}
            </div>
          </div>

          <hr className="my-2 sm:my-10 border-[#F3F4F6]" />

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-10 text-center">
            {stats.map((item: any, i: number) => (
              <div key={i}>
                <div className="w-24 h-24 mx-auto rounded-full border-[14px] border-[#14A800] flex items-center justify-center font-bold text-lg">
                  {item.value}
                </div>
                <div className="text-[10px] sm:text-[12px] mt-4 text-[#6B7280] font-bold tracking-wide">
                  {item.label}
                </div>
              </div>
            ))}
          </div>
        </div>

{proposal.sections
  ?.filter((s: any) => !s.hidden)
  .sort((a: any, b: any) => a.order - b.order)
  .map((section: any, index: number) => {

  if (section.type === "simple-text") {
  return (
    <div key={index} id={`section-${section.id}`} className="bg-white rounded-3xl p-14 shadow-sm">

      {index === 0 && (
        <>
          <h2 className="text-[23px] sm:text-[34px] font-extrabold text-[#001E00] text-center">
            {proposal.title || "Estrat Solutions"}
          </h2>
          <div className="w-20 h-2 bg-[#14A800] mx-auto mt-4 mb-12 rounded-full"></div>
        </>
      )}

      <div className="flex items-center gap-3 mb-6">
        <div className="w-8 h-8 rounded-full flex items-center justify-center">
          <Info size={30} className="text-[#14A800]" />
        </div>
        <h3 className="text-[22px] sm:text-[28px] font-bold text-[#001E00]">
          {section.title}
        </h3>
      </div>

      <p className="text-[#4B5563] leading-relaxed text-[17px] max-w-4xl">
        {section.content?.text}
      </p>
    </div>
  );
}

if (section.type === "feature-grid") {
  const isOffer = section.id === "offer";

  return (
    <div key={index} id={`section-${section.id}`} className="bg-white rounded-3xl p-12 shadow-sm">
      <div className="flex items-center justify-start gap-3">
        <div className="w-8 h-8 rounded-full flex items-center justify-center">
       {isOffer ? <FileCheck size={26} className="text-[#14A800]" /> : <Target size={26} className="text-[#14A800]" />}
       </div>
      <h2 className="text-[22px] sm:text-[24px] font-extrabold text-[#001E00]">
        {section.title}
      </h2>
      </div>

      <div className="bg-[#14A800] mt-3 mb-10 rounded-full"></div>

      <div className={`grid ${isOffer ? "md:grid-cols-3" : "md:grid-cols-2"} gap-6`}>
        {section.content?.items?.map((item: any, i: number) => {
          const Icon = getIconFromKeyword(item.title);
          return (
            <div key={i} className="bg-gray-50 rounded-2xl p-6">
              <div className="flex gap-3">
                <Icon className="text-[#14A800] mt-1 mb-4" size={46} />
              <div>
              <h3 className="font-bold text-[#001E00]">
                {item.title}
              </h3>
              <p className="text-gray-600 mt-2 text-sm">
                {item.description}
              </p>
              </div>
              </div>

            </div>
          );
        })}
      </div>
    </div>
  );
}

if (section.type === "dark-grid") {
  return (
    <div key={index} id={`section-${section.id}`} className="bg-[#052E16] text-white p-12 rounded-3xl">

      <div className="flex items-center gap-3">
        <AlertTriangle size={26} className="text-[#14A800]" />
        <h2 className="text-[22px] sm:text-[28px] font-bold">
          {section.title}
        </h2>
      </div>

      <div className="grid md:grid-cols-3 gap-6 mt-10">
        {section.content?.items?.map((item: any, i: number) => (
          <div
            key={i}
            className="bg-white/5 border border-white/10 rounded-xl p-6"
          >
            <h3 className="text-[#14A800] font-bold">
              {item.title}
            </h3>
            <p className="text-white/80 text-sm mt-2">
              {item.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}

if (section.type === "steps") {
  return (
    <div key={index} id={`section-${section.id}`} className="bg-white rounded-3xl p-12 shadow-sm">

      <div className="flex items-center gap-3 mb-8">
        <Route
          size={30}
          strokeWidth={2.2}
          className="text-[#14A800]"
        />
        <h2 className="text-[22px] sm:text-[28px] font-bold text-[#001E00]">
          {section.title}
        </h2>
      </div>

      <div className="grid md:grid-cols-3 gap-6">
        {section.content?.steps?.map((step: any, i: number) => (
          <div key={i} className="bg-gray-50 rounded-2xl p-6">
            <div className="w-10 h-10 rounded-full bg-[#14A800] text-white flex items-center justify-center font-bold mb-4">
              {i + 1}
            </div>
            <h3 className="text-[16px] sm:text-[18px] font-bold text-[#001E00]">
              {step.title}
            </h3>
            <p className="text-[#4B5563] mt-2 text-sm whitespace-pre-line">
              {step.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}

if (section.type === "text-with-points") {
  return (
    <div key={index} id={`section-${section.id}`} className="bg-white rounded-3xl p-12">

      <div className="flex items-center gap-3 mb-8">
          <Lightbulb
            size={32}

            className="text-[#14A800] items-center"
          />

        <h2 className="text-[28px] font-bold text-[#001E00]">
          {section.title}
        </h2>
      </div>

      <div className="grid md:grid-cols-2 gap-12 items-center">

        <div>
          <p className="text-[#4B5563] leading-relaxed mb-8">
            {section.content?.text}
          </p>

          <div className="space-y-4">
            {section.content?.points?.map((point: string, i: number) => (
              <div key={i} className="flex items-start gap-3">
                <CheckCircle size={24} className="text-[#14A800] mt-1" />
                <p className="text-sm text-[#374151]">{point}</p>
              </div>
            ))}
          </div>
        </div>

<div className="border border-dashed border-gray-300 rounded-2xl p-10 text-center bg-[#F9F9F9]">

<Wand2
  size={42}
  strokeWidth={1.8}
  className="text-[#14A800] mx-auto mb-6 opacity-40"
/>

          <p className="text-[#001E00] font-semibold text-lg leading-relaxed whitespace-pre-line">
            {section.content?.highlight}
          </p>

        </div>

      </div>
    </div>
  );
}

 if (section.type === "testimonial-grid") {
  return (
    <div key={index} id={`section-${section.id}`} className="bg-white rounded-3xl p-12">

      <div className="flex items-center gap-3 mb-10">
        <div className="w-8 h-8 rounded-md border-2 border-[#14A800] flex items-center justify-center">
          <Star size={16} className="text-[#14A800]" />
        </div>
        <h2 className="text-[28px] font-bold text-[#001E00]">
          {section.title}
        </h2>
      </div>

      <div className="grid md:grid-cols-3 gap-6">
        {section.content?.items?.map((item: any, i: number) => {

          const initials = item.name
            ?.split(" ")
            .map((n: string) => n[0])
            .join("")
            .substring(0, 2)
            .toUpperCase();

          return (
            <div
              key={i}
              className="relative bg-[#F9F9F9] rounded-2xl p-8 shadow-sm"
            >

              <div className="absolute top-6 right-6 text-[#14A800]/30 text-4xl font-bold">
                “
              </div>

              <p className="text-sm text-gray-600 leading-relaxed mb-8">
                "{item.quote}"
              </p>

              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full border flex items-center justify-center text-sm font-bold text-[#14A800] bg-white">
                  {initials}
                </div>

                <div>
                  <p className="font-semibold text-[#001E00]">
                    {item.name}
                  </p>
                  <p className="text-xs text-gray-500">
                    {item.position}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

if (section.type === "website-showcase") {
  return <WebsiteShowcaseSection key={section.id} section={section} primaryColor={proposal.customization?.primaryColor || "#14A800"} />;
}

if (section.type === "portfolio-grid") {
  return (
    <div key={index} id={`section-${section.id}`} className="bg-white rounded-3xl p-12 shadow-sm">
      <h2 className="text-[28px] text-center font-bold text-[#001E00]">
        {section.title}
      </h2>
      <div className="w-20 h-2 bg-[#14A800] mx-auto mt-4 mb-7 rounded-full"></div>

      {section.content?.subtitle && (
        <p className="text-[#6B7280] text-center">
          {section.content.subtitle}
        </p>
      )}

      <div className="grid md:grid-cols-3 gap-6 mt-10">
        {section.content?.projects?.map((project: any, i: number) => (
          <div key={i} className="rounded-2xl overflow-hidden shadow-sm">
            <img
              src={project.image}
              alt={project.title}
              className="w-full h-52 object-contain bg-slate-100"
            />
            <div className="p-4 bg-white">
              <p className="font-semibold text-sm">
                {project.title}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

if (section.type === "call-to-action") {
  return (
    <div key={index} id={`section-${section.id}`} className="bg-white rounded-3xl p-16 text-center">

      <div className="w-20 h-20 mx-auto rounded-full bg-[#E6F4EA] flex items-center justify-center mb-8">
        <Handshake
          size={34}
          strokeWidth={1.8}
          className="text-[#14A800]"
        />
      </div>

      <h2 className="text-[24px] sm:text-[32px] font-extrabold text-[#001E00]">
        {section.title}
      </h2>

      <p className="text-[#6B7280] mt-6 max-w-2xl mx-auto leading-relaxed">
        {section.content?.text}
      </p>

      <a
        href={section.content?.buttonLink || proposal.hireLink || BRAND_CONFIGS[proposal.brand as BrandType]?.upworkProfile || "#"}
        target="_blank"
        rel="noopener noreferrer"
        className="mt-10 cursor-pointer inline-flex items-center gap-2 bg-[#14A800] text-white px-10 py-4 rounded-xl font-semibold shadow-md hover:opacity-90 transition"
      >
        <SiUpwork size={20} />
        {section.content?.buttonText}
      </a>

    </div>
  );
}

    return null;
  })}

        <div className="fixed flex items-end sm:bottom-6 bottom-4 right-4 sm:items-center sm:justify-center top-1/2 -translate-y-1/2">
          <button
            onClick={() => {
              // Link to the Business Developer's (brand's) Upwork profile — that's
              // where the client actually hires them. Fall back to the CTA section.
              const url = proposal.hireLink || BRAND_CONFIGS[proposal.brand as BrandType]?.upworkProfile;
              if (url) window.open(url, "_blank", "noopener");
              else document.getElementById("section-cta")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="bg-[#14A800] text-white px-8 py-4 rounded-full shadow-xl flex items-center gap-2 font-semibold hover:scale-105 transition"
          >
            <SiUpwork size={20} />
            Hire Me
          </button>
        </div>

        <div className="fixed left-6 top-1/2 -translate-y-1/2">
  <div className="bg-white rounded-full shadow-lg px-2 py-4 flex flex-col gap-5">

    {proposal.sections
      ?.filter((s: any) => !s.hidden)
      .sort((a: any, b: any) => a.order - b.order)
      .map((section: any, i: number) => {

        const sectionIcons: Record<string, any> = {
          "simple-text": Info,
          "feature-grid": FileCheck,
          "dark-grid": AlertTriangle,
          "steps": Route,
          "text-with-points": Lightbulb,
          "testimonial-grid": Star,
          "portfolio-grid": FileCheck,
          "call-to-action": Handshake,
        };

        const Icon = sectionIcons[section.type] || Info;

        return (
          <button
            key={i}
            onClick={() => {
              const el = document.getElementById(`section-${section.id}`);
              el?.scrollIntoView({ behavior: "smooth" });
            }}
            className="group relative flex items-center justify-center"
          >
            <Icon
              size={22}
              className="text-gray-400 group-hover:text-[#14A800] transition"
            />

            <span className="absolute left-10 whitespace-nowrap bg-[#001E00] text-white text-xs px-3 py-1 rounded-md opacity-0 group-hover:opacity-100 transition">
              {section.title}
            </span>
          </button>
        );
      })}
  </div>
</div>

      </div>
    </div>
  );
};

export default ClassicTemplate;
